const ADDRESS = '50 Concord Commons Pl SW, Concord, NC 28027';

/** Lightweight Google Maps embed — the no-API-key `output=embed` form, not the billable
 * Maps JavaScript/Embed API. Loaded lazily since it's below the fold everywhere it appears. */
export function MapEmbed() {
  return (
    <iframe
      title="Nine80 Hair Studio location map"
      className="w-full h-72 rounded-card border border-border"
      loading="lazy"
      referrerPolicy="no-referrer-when-downgrade"
      src={`https://www.google.com/maps?q=${encodeURIComponent(ADDRESS)}&output=embed`}
    />
  );
}

export function directionsUrl(): string {
  return `https://www.google.com/maps/dir/?api=1&destination=${encodeURIComponent(ADDRESS)}`;
}
